import { solution } from '../../lib/words'
import { Cell } from './Cell'

type Props = {
  theme: string
}

export const EmptyRow = ({ theme }: Props) => {
  const emptyCells = Array.from(Array(solution.length))

  return (
    <div className="mb-1 flex justify-center">
      {emptyCells.map((_, i) => (
        <Cell key={i} theme={theme} />
      ))}
    </div>
  )
}
